export const publicNavLinks = [
    { name: "Courses", to: "/races" },
    { name: "Classements", to: "/standings" },
    { name: "Pilotes", to: "/drivers" },
    { name: "Écuries", to: "/teams" },
    // { name: "S'inscrire", to: "/register" },
];
